<template>
    <div class="other-options">
        <div class="other-options__back">
            <a-button
                type="button"
                variant="none"
                :aria-label="$t('shared.backFromOtherOptions')"
                @click="$emit('close-options')"
            >
                <img class="mr-1 clickable" :src="backIcon" alt="" />
            </a-button>
        </div>
        <a-form-select
            v-model="selectedClient"
            :options="options"
            :placeholder="$t('shared.placeholders.client')"
            option-label="name"
            searchable
            track-by="value"
        />
        <a-button
            type="button"
            class="cred-button"
            :disabled="!selectedClient?.value"
            @click="redirect"
        >
            {{ $t('shared.continue') }}
        </a-button>
    </div>
</template>
<script>
export default {
    name: 'OtherOptions',
    props: {
        providers: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            isDropdownOpen: false,
            selectedClient: null,
        }
    },
    computed: {
        backIcon() {
            return new URL("../../assets/images/icons/arrow-left.svg", import.meta.url).href;
        },
        options() {
            return Object.entries(this.providers).map(([key, value]) => {
                return {
                    name: this.friendlyName(key),
                    value: value
                }
            });
        }
    },
    methods: {
        redirect() {
            const url = this.selectedClient?.value;
            if (!url) {
                return;
            }
            window.location.replace(url);
        },
        friendlyName(name) {
            const names = name.split('_');
            let capNames = [];
            names.forEach(val => {
                capNames.push(String(val).charAt(0).toUpperCase() + String(val).slice(1));
            });
            return capNames.join(" ")
            .replace('Openid Connect', 'Staff Login')
            .replace('Edurooms Openid Connect', 'Parents Login');
        }
    }
}
</script>
<style lang="scss">
.other-options {
    text-align: left;
}
.other-options__back {
    margin-bottom: 12px;
    text-align: left;
}
button.cred-button {
    position: relative;
    border: none;
    margin-top: 12px;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
    font-size: 16px;
    color: #fff;
    background: var(--buttons-colors-primary-hex, #662E80);
    border-radius: 8px;
    outline: none;
    padding: 16px;
    width: 100%;
    cursor: pointer;

    &:disabled {
        background: #f3f3f3;
        color: #adadad;
    }

    &:focus {
        &:before {
            content: '';
            position: absolute;
            top: -3px;
            left: -3px;
            height: calc(100% + 6px);
            width: calc(100% + 6px);
            border: 1px solid #662E80;
            border-radius: 8px;
            box-sizing: border-box;
        }
    }
}
</style>